import { render, staticRenderFns } from "./ShipOceanRaceStatusWidget.vue?vue&type=template&id=778794ca&scoped=true"
import script from "./ShipOceanRaceStatusWidget.vue?vue&type=script&lang=js"
export * from "./ShipOceanRaceStatusWidget.vue?vue&type=script&lang=js"
import style0 from "./ShipOceanRaceStatusWidget.vue?vue&type=style&index=0&id=778794ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778794ca",
  null
  
)

export default component.exports